import React from "react";
import { Banknote, Loader2 } from "lucide-react";
import { catalogoIndisponivelCopy, loadFailureCopy } from "../../lib/cedenteOperations";
import { ICON_MAP } from "./config";

// R5 — extraído MECANICAMENTE de pages/NewOperation.jsx (JSX verbatim; o
// estado vive no componente-pai e chega por `ctx`).
export default function StepProduto({ ctx }) {
  const {
    cfg,
    isCedenteMode,
    products,
    productsLoading,
    boUnavailable,
    catalogState,
    loadFailedParts,
    loadError,
    catalogReason,
    productId,
    loadInitial,
    enabledCount,
    handleProductChange,
  } = ctx;
  return (
    <div className="zemo-card p-6 space-y-4" data-testid="step-1-content">
      <h2 className="text-lg font-semibold tracking-tight">Selecione o produto habilitado</h2>
      <p className="text-sm text-zinc-500 -mt-2">
        {cfg.copy.produtosHint}
      </p>

      {/* Estado: carregando */}
      {productsLoading && (
        <div className="flex items-center gap-2 text-sm text-zinc-500 py-6" data-testid="products-loading">
          <Loader2 className="h-4 w-4 animate-spin" /> Carregando produtos habilitados...
        </div>
      )}

      {/* Estado: erro de INFRA ao carregar (≠ boUnavailable ≠ 0-habilitados). Causa é
          rede/servidor, não política — não sugerir nada sobre habilitação. */}
      {!productsLoading && loadError && (
        <div role="alert" className="rounded-md p-3 border border-red-200 bg-red-50 text-[13px] text-red-800 space-y-2" data-testid="products-load-error">
          <div>{loadFailureCopy(loadFailedParts, cfg.copy.loadLabels)} Verifique sua conexão e tente novamente.</div>
          <button onClick={loadInitial} className="underline font-medium" data-testid="products-load-retry-btn">
            Tentar novamente
          </button>
        </div>
      )}

      {/* Estado: BO indisponivel → fail-closed (tudo cinza + aviso). Nunca sugerir habilitado. */}
      {!productsLoading && !loadError && boUnavailable && (
        <div className="rounded-md p-3 border border-amber-200 bg-amber-50 text-[13px] text-amber-800" data-testid="products-bo-unavailable">
          {/* `unavailable_reason` (aditivo, round 3): "seu cadastro ainda
              não está completo" (no_regent, permanente) é uma frase MUITO
              diferente de "tente de novo em instantes" (bo_down). */}
          {isCedenteMode
            ? catalogoIndisponivelCopy(catalogReason, cfg.copy.produtosBoUnavailable)
            : cfg.copy.produtosBoUnavailable}
        </div>
      )}

      {/* Estado: parceiro sem nenhum produto habilitado (BO respondeu, mas nada acende). */}
      {!productsLoading && !loadError && !boUnavailable &&
        (catalogState === "BO_SEM_PRODUTOS" || (!catalogState && enabledCount === 0)) && (
        <div className="rounded-md p-3 border border-amber-200 bg-amber-50 text-[13px] text-amber-800" data-testid="products-none-enabled">
          {cfg.copy.produtosNoneEnabled}
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        {products.map((p) => {
          const Icon = ICON_MAP[p.icon] || Banknote;
          const selected = p.id === productId;
          const disabled = !p.enabled;
          return (
            <button
              key={p.id}
              onClick={() => !disabled && handleProductChange(p.id)}
              disabled={disabled}
              data-testid={`product-card-${p.id}`}
              className={`text-left p-4 rounded-md border-2 transition-all
                    ${disabled ? "border-zinc-100 bg-zinc-50 opacity-50 cursor-not-allowed" : ""}
                    ${!disabled && selected ? "border-[#0055FF] bg-[#0055FF]/5" : ""}
                    ${!disabled && !selected ? "border-[var(--zemo-border)] hover:border-zinc-300" : ""}
                  `}
            >
              <div className="flex items-start gap-3">
                <div className={`h-10 w-10 rounded-md flex items-center justify-center
                      ${disabled ? "bg-zinc-100 text-zinc-400" : ""}
                      ${!disabled && selected ? "bg-[#0055FF] text-white" : ""}
                      ${!disabled && !selected ? "bg-zinc-100 text-zinc-700" : ""}
                    `}>
                  <Icon className="h-5 w-5" />
                </div>
                <div className="flex-1">
                  <div className={`font-semibold ${disabled ? "text-zinc-400" : "text-zinc-900"}`}>
                    {p.nome}
                    {disabled && (
                      <span className="ml-2 text-[11px] font-normal text-zinc-400">
                        {p.bo_only ? "(fale com a Zemo)" : "(indisponivel)"}
                      </span>
                    )}
                  </div>
                  <div className={`text-[12px] mt-0.5 ${disabled ? "text-zinc-300" : "text-zinc-500"}`}>{p.descricao}</div>
                  {/* Modo reduzido (01(b)): o card do cedente NÃO exibe faixa de taxa —
                      só o prazo máximo, que é regra operacional do preenchimento. */}
                  {!disabled && (
                    <div className="mt-2 flex items-center gap-3 text-[11px] text-zinc-600 font-mono-num">
                      {cfg.showRates && <span>Taxa {p.taxa_min}-{p.taxa_max}% a.m.</span>}
                      <span>Ate {p.prazo_max_dias}d</span>
                    </div>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
